import React from "react";
import { Link } from 'react-router-dom';

export default function FooterLoggedOut() {
  return(
    <p className = "FooterLinks">
      <Link to='/'>
        Home
      </Link>
      |
      <Link to='/requests'>
        Requests
      </Link>
      |
      <Link to='/request-status'>
        Request Status
      </Link>
	</p>
  );
}